import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-baskets-product',
  templateUrl: './baskets.component.html',
  styleUrls: ['./baskets.component.css']
})
export class BasketsProductComponent implements OnInit {

  @Input() baskets;
  @Input() basketHeight;

  constructor() { }

  ngOnInit() {
    this.baskets = [];
  }
}
